module.exports = __webpack_public_path__ + "img/3xh.9d53c0cb.png";